import { Directive, HostListener, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({ selector: '[upperHint]' })
export class UpperHintDirective {
  constructor(public el: ElementRef, public renderer: Renderer2) {}

  @Input() upperHint: string;

  ngOnInit() {
    // Use renderer to render the emelemt with styles
    //this.renderer.setElementStyle(this.el.nativeElement, 'visibility', 'hidden');
  }

  @HostListener('keyup') onMouseEnter() {
    var l = __ngRendererCreateElementHelper(this.renderer, this.el, 'label');

    if (this.upperHint == '' || this.upperHint == undefined || this.upperHint == null) {
      this.renderer.setStyle(this.el.nativeElement, 'visibility', 'hidden');
    } else {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'visible');
    }
  }
}
type AnyDuringRendererMigration = any;

function __ngRendererSplitNamespaceHelper(name: AnyDuringRendererMigration) {
  if (name[0] === ':') {
    const match = name.match(/^:([^:]+):(.+)$/);
    return [match[1], match[2]];
  }
  return ['', name];
}

function __ngRendererCreateElementHelper(
  renderer: AnyDuringRendererMigration,
  parent: AnyDuringRendererMigration,
  namespaceAndName: AnyDuringRendererMigration,
) {
  const [namespace, name] = __ngRendererSplitNamespaceHelper(namespaceAndName);
  const node = renderer.createElement(name, namespace);
  if (parent) {
    renderer.appendChild(parent, node);
  }
  return node;
}
